module.exports = __webpack_public_path__ + "static/premios@2x-3de4189c2127daba003d544b4b8b9b27.png";